// extracted by mini-css-extract-plugin
export default {"selected":"selected-GgYAX","selectableParagraph":"selectableParagraph-RR3GO"};